/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedManualPaymentList } from '../models/PaginatedManualPaymentList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ManualPaymentEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns PaginatedManualPaymentList
   * @throws ApiError
   */
  public manualPaymentList({
    drivingSchoolId,
    limit,
    offset,
    ordering,
    paymentType,
    serviceTime,
  }: {
    drivingSchoolId?: string,
    /**
     * Number of results to return per page.
     */
    limit?: number,
    /**
     * The initial index from which to return the results.
     */
    offset?: number,
    /**
     * Which field to use when ordering the results.
     */
    ordering?: 'created_at' | '-created_at' | 'payment_type' | '-payment_type' | 'student_name' | '-student_name' | 'amount' | '-amount',
    /**
     * * `cash` - cash
     * * `bank_transfer` - bank_transfer
     * * `external_bank_transfer` - external_bank_transfer
     */
    paymentType?: 'bank_transfer' | 'cash' | 'external_bank_transfer',
    serviceTime?: string,
  }): CancelablePromise<PaginatedManualPaymentList> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/manual-payment/',
      query: {
        'driving_school_id': drivingSchoolId,
        'limit': limit,
        'offset': offset,
        'ordering': ordering,
        'payment_type': paymentType,
        'service_time': serviceTime,
      },
    });
  }

}
